<template>
  <v-card class="ep-rechner-box">
    <v-col cols="12" class="p-0">
      <div class="v-card__title p-0">
        <h2 class="v-card--head--title">
          {{ selectedLang.DistributorTile1 }}
        </h2>
      </div>
    </v-col>
    <v-card-text
      ><v-form ref="distributorform" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="6">
            <v-btn block class="btn-ep-back-to" @click="go4ward('flyway')">{{
              selectedLang.DistributorTile2
            }}</v-btn>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn block class="btn-ep-back-to" @click="go4ward('railway')">{{
              selectedLang.DistributorTile3
            }}</v-btn>
          </v-col>
        </v-row>
      </v-form></v-card-text
    >
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "DistributorTile",
  data: function () {
    return {};
  },
  computed: {
    ...mapState([
      "selectedDiv",
      "selectedLang",
      "railway",
      "flyway",
      "distributed",
    ]),
  },
  methods: {
    ...mapActions(["setSelectedDiv", "setVar"]),
    go4ward(way) {
      this.setVar({ pos: way, val: true });
      this.setVar({ pos: "distributed", val: true });
    },
  },
};
</script>
